import React, { useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useUserInfo } from '@/hooks'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import { Toast } from 'react-vant';
import { VerActionType, type VerActionItem } from './index.type'
import { useSendCode } from '@/hooks/useSendCode'
import Ripple from '@/components/Ripple'
export default React.memo(function SelectVerification() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { t } = useTranslation()
    const { userInfo } = useUserInfo()
    const { sendCode, sendCodeLoading } = useSendCode()
    const VerActionItems = useMemo<VerActionItem[]>(
        () => {
            const items: VerActionItem[] = []
            // 只有当用户有手机号时才显示手机验证选项
            if (userInfo?.phone) {
                items.push({
                    icon: "/icon/phone-icon.svg",
                    title: t('手机号'),
                    description: t('通过手机号验证码验证'),
                    actionType: VerActionType.PhoneVer
                })
            }
            // 只有当用户有邮箱时才显示邮箱验证选项
            if (userInfo?.email) {
                items.push({
                    icon: "/icon/email-icon.svg",
                    title: t('邮箱'),
                    description: t('通过邮箱验证码验证'),
                    actionType: VerActionType.EmailVer
                })
            }
            // 只有当用户绑定了谷歌验证器时才显示谷歌验证选项
            if (userInfo?.is_bind_google) {
                items.push({
                    icon: "/icon/google-ver-icon.svg",
                    title: t('谷歌验证器'),
                    description: t('通过谷歌验证器验证'),
                    actionType: VerActionType.GoogleVer
                })
            }

            return items
        },
        [userInfo?.phone, userInfo?.email, userInfo?.is_bind_google]
    )
    const handleSelectVer = async (actionType: VerActionType) => {
        if (actionType === VerActionType.PhoneVer || actionType === VerActionType.EmailVer) {
            if (sendCodeLoading) return
            Toast.loading(t('正在发送验证码'))
            navigate(`/change-account/ver-old-account-code`, {
                state: {
                    account: actionType === VerActionType.PhoneVer ? userInfo?.phone || '' : userInfo?.email || '',
                    verification: actionType,
                    ...state
                }
            })
            await sendCode({
                account: actionType === VerActionType.PhoneVer ? userInfo?.phone || '' : userInfo?.email || '',
                scene: 'change_account',
            })

        } else {
            navigate(`/change-account/ver-old-account-code`, {
                state: {
                    account: '',
                    ...state
                }
            })
        }
    }
    return (
        <PageLayout>
            <Header leftChildren={<Back />} />
            <div className='px-6 py-6'>
                <div className='text-3.75 font-medium text-black border-[0.5px] border-b-solid border-b-[#808080] pb-2'>{t('选择验证方式')}</div>
                <div className='mt-6 space-y-2'>
                    {VerActionItems.map((item) => (
                        <Ripple key={item.actionType} className="rounded-2 w-full">
                        <div className='flex justify-between items-center py-3' key={item.actionType} onClick={() => handleSelectVer(item.actionType)}>
                            <div className='text-sm text-[#333333]'>{item.description}</div>
                            <div><img className='w-2' src="/icon/right-info.svg" /></div>
                        </div>
                        </Ripple>
                    ))}
                </div>
            </div>
        </PageLayout>
    )
})
